// React
import React, { Component } from 'react';

// Redux
import { connect } from 'react-redux';
import * as actions from 'actions';

// Styles
import { calendarStyles } from './styles';

// Vendor Libraries
import map from 'lodash/map';

// Utilities
import { utils } from '../../constants';

// Components
import BookingFlow from 'components/Dialog/BookingFlow';
import Timeslots from './Timeslots/Timeslots';
import NavControls from './NavControls/NavControls';

const { toWeekDayName, toDateString } = utils;

/*

Props:

• titleText
• data
• style

*/

const componentStyles = { ...calendarStyles };

const _applyStyleModifiers = props => {
    // const { logoURL, size } = props;
    const styles = { ...componentStyles };

    return { ...styles, container: { ...styles.container, ...props.style } };
};

class CalendarComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            booking: {},
            height: '0',
            width: '0',
        };
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    }

    componentDidMount() {
        if (this.props.userId) {
            // console.log('FYI: getClientData is being called in Calendar. Hopefully this fixed the calendar SBM no-show issue.');
            this.props.getClientData(this.props.userId); // THIS MAY CAUSE DUPLICATION ISSUES WITH BOOKINGS // uncommentig to hopefully fix calendar no show issue with SBM token expiration
        }
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
    }

    updateWindowDimensions() {
        this.setState({ width: window.innerWidth, height: window.innerHeight });
    }

    handleNextClick = () => {
        const {
            nextWeekStartDate,
            providerId,
            serviceId,
        } = this.props.calendarWeek;
        const date = toDateString(nextWeekStartDate);
        // console.log('GETTING CAL FROM NEXT CLICK');
        // console.log('SERVICE ID for NEXT CAL WEEK', serviceId);

        this.props.getCalendar(providerId, serviceId, date);
    };

    handlePrevClick = () => {
        const {
            lastWeekStartDate,
            providerId,
            serviceId,
        } = this.props.calendarWeek;
        const date = toDateString(lastWeekStartDate);
        // console.log('GETTING CALENDAR FROM PREV CLICK');
        console.log('serviceId for pastCal Week', serviceId);

        this.props.getCalendar(providerId, serviceId, date);
    };

    handleSlotSelection = (time, date, index) => {
        // index can be used to manipulate the slot - hide it change the colour etc.diable clicking - likely hiding would be best
        const {
            serviceId,
            providerId,
            thisWeekStartDate,
            selectedProviderData,
        } = this.props.calendarWeek;
        // console.log(this.props.location, 'IS LOCATION');
        this.props.setBookingData({
            date,
            index,
            providerId,
            selectedProviderData,
            serviceId,
            thisWeekStartDate,
            time,
        });
    };

    render() {
        const styles = _applyStyleModifiers(this.props);
        // TODO: Convert string into array of paragraphs using const myArray = this.props.bodyText.split('\n') then loop over array adding div for each with required spacing

        let staticWidth = {};
        if (this.state.width < 400) {
            staticWidth = {
                justifyContent: 'flex-start',
                overflowX: 'scroll',
                paddingLeft: 0,
                paddingRight: 0,
                width: 500,
            };
        }
        let shadow = {};
        if (this.state.width < 400) {
            shadow = {
                backgroundColor: 'white',
                boxShadow: '-0px -5px 20px rgba(0,0,0,0.9)',
                height: '105%',
                left: 'calc(100vw - 0px)',
                position: 'absolute',
                top: 0,
                width: 5,
            };
        }

        if (this.props.calendarWeek) {
            const {
                lastWeekStartDate,
                firstWeekStartDate,
                selectedProviderData,
            } = this.props.calendarWeek;
            const canGoBack =
                lastWeekStartDate >= firstWeekStartDate ? true : false;

            return (
                <div style={{ ...styles.outerContainer }}>
                    <div style={{ ...shadow }} />
                    {this.props.calendarWeek && (
                        <div style={{ ...styles.container, ...staticWidth }}>
                            <NavControls
                                onNextClick={this.handleNextClick}
                                onPrevClick={this.handlePrevClick}
                                canGoBack={canGoBack}
                                styles={styles} // TODO: these need to be put into the component itself at some point
                            />
                            {/* PASS IN THREE DIFFERENT TIMESLOTS WITH A PAST PRESENT AND FUTURE MATRIX THEN USE THE SWIPABLE COMP TO SWIPE TO NEXT AND PAST TIMESLOTS */}
                            <Timeslots
                                matrix={this.props.matrix}
                                calendarWeek={this.props.calendarWeek}
                                styles={styles} // TODO: these need to be put into the component itself at some point
                                screenWidth={this.state.width}
                                handleSlotSelection={this.handleSlotSelection}
                            />
                        </div>
                    )}
                </div>
            );
        } else {
            return <div />;
        }
    }
}

const mapStateToProps = ({ calendar, auth, client }) => {
    return {
        calendarWeek: calendar.week,
        // userData: client.clientData,
        matrix: calendar.week ? calendar.week.matrix : null,
        serverError: client.serverError,
        user: auth.authData,
        userEmail: auth.authData ? auth.authData.email : null,
        userId: auth.authData ? auth.authData.id : null,
    };
};

export const Calendar = connect(
    mapStateToProps,
    actions,
)(CalendarComponent);



// WEBPACK FOOTER //
// ./src/js/components/Calendar/Calendar.jsx